"use client";
import {
	RiAndroidLine,
	RiAppleLine,
	RiDiscordLine,
	RiDrinksLine,
	RiLifebuoyLine,
	RiLoginBoxLine,
	RiSettings4Line,
	RiUserAddLine,
} from "@remixicon/react";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuGroup,
	DropdownMenuItem,
	DropdownMenuSeparator,
	DropdownMenuTrigger,
} from "@workspace/ui/components/dropdown-menu";
import { cn } from "@workspace/ui/lib/utils";
import { TopNavTheme } from "./top-nav-theme";

export interface TopNavProfilePublicProps {
	onReportIssues?: () => void;
}

export function TopNavProfilePublic({
	onReportIssues,
}: TopNavProfilePublicProps) {
	const handleLeaveTipClick = () => {
		window.open(
			"https://buy.stripe.com/7sIcMO56o8fUd7q288",
			"_blank",
			"noopener,noreferrer",
		);
	};

	const handleReportIssuesClick = () => {
		if (onReportIssues) {
			onReportIssues();
		} else {
			const email = "support@tryhumble.com";
			const subject = encodeURIComponent("Issue Report");
			const mailtoLink = `mailto:${email}?subject=${subject}`;
			window.location.href = mailtoLink;
		}
	};

	const handleSignInClick = () => {
		// Capture the current full URL including hash for scroll position
		const currentUrl =
			window.location.pathname + window.location.search + window.location.hash;
		window.location.href = `/auth/signin?next=${encodeURIComponent(currentUrl)}`;
	};

	const handleSignUpClick = () => {
		window.location.href = "/auth/signup";
	};

	const handleDiscordJoin = () => {
		window.open("https://discord.gg/BWCeC5jVQt", "_blank");
	};

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<button
					type="button"
					className={cn(
						"relative flex h-8 w-8 items-center justify-center rounded-full outline-none transition-all duration-200",
						"hover:ring-4 hover:ring-primary/10 active:scale-95 active:ring-primary/20",
						"focus-visible:ring-2 focus-visible:ring-primary/30",
					)}
					aria-label="Menu"
				>
					<RiSettings4Line className="h-5 w-5" />
				</button>
			</DropdownMenuTrigger>
			<DropdownMenuContent
				align="end"
				sideOffset={8}
				className="w-56 rounded-2xl"
			>
				<DropdownMenuGroup>
					<TopNavTheme isAtTop={true} />
				</DropdownMenuGroup>
				<DropdownMenuSeparator />
				<DropdownMenuGroup>
					<DropdownMenuItem
						onClick={handleDiscordJoin}
						className="cursor-pointer rounded-sm"
					>
						<RiDiscordLine className="h-4 w-4" />
						Join Discord
					</DropdownMenuItem>
					<DropdownMenuItem
						onClick={handleLeaveTipClick}
						className="cursor-pointer rounded-sm"
					>
						<RiDrinksLine className="h-4 w-4" />
						Buy Me Coffee
					</DropdownMenuItem>
					<DropdownMenuItem
						onClick={handleReportIssuesClick}
						className="cursor-pointer rounded-sm"
					>
						<RiLifebuoyLine className="h-4 w-4" />
						Contact Support
					</DropdownMenuItem>
				</DropdownMenuGroup>
				<DropdownMenuSeparator />
				<DropdownMenuGroup>
					<DropdownMenuItem asChild className="cursor-pointer rounded-sm">
						<a
							href="https://apps.apple.com/us/app/humble-festivals-with-friends/id6749406367"
							target="_blank"
							rel="noopener noreferrer"
						>
							<RiAppleLine className="h-4 w-4" />
							iOS
						</a>
					</DropdownMenuItem>
					<DropdownMenuItem asChild className="cursor-pointer rounded-sm">
						<a
							href="https://play.google.com/store/apps/details?id=com.humbleos.mobile&hl=en_US"
							target="_blank"
							rel="noopener noreferrer"
						>
							<RiAndroidLine className="h-4 w-4" />
							Android
						</a>
					</DropdownMenuItem>
				</DropdownMenuGroup>
				<DropdownMenuSeparator />
				<DropdownMenuItem
					onClick={handleSignInClick}
					className="cursor-pointer rounded-sm"
				>
					<RiLoginBoxLine className="h-4 w-4" />
					Sign In
				</DropdownMenuItem>
				<DropdownMenuItem
					onClick={handleSignUpClick}
					className="hover:!text-radix-iris-9 cursor-pointer rounded-sm rounded-b-xl text-radix-iris-9 hover:bg-radix-iris-4"
				>
					<RiUserAddLine className="h-4 w-4" />
					Sign Up
				</DropdownMenuItem>
			</DropdownMenuContent>
		</DropdownMenu>
	);
}
